import { StateCreator } from "zustand";
import { deleteAllEventrCalendars } from "../../feat/calendar/calendarProvider";
import { BoundStore } from "../bound.store";

interface CalendarState {
  /** Global on/off for calendar sync (per-itinerary inclusion lives in filterTargets[id].calendar). */
  calendarSyncEnabled: boolean;
  /** Whether the device has granted calendar permission. Re-checked on launch, not authoritative when stale. */
  calendarPermissionGranted: boolean;
  /** Whether calendar permission was explicitly denied (can't be re-prompted in-app, route to settings). */
  calendarPermissionDenied: boolean;
}
interface CalendarActions {
  setCalendarSyncEnabled: (enabled: boolean) => void;
  setCalendarPermissionGranted: (granted: boolean) => void;
  setCalendarPermissionDenied: (denied: boolean) => void;
  /** Removes every Eventr calendar from the device. Used on logout. */
  clearCalendars: () => void;
}
export interface CalendarSlice extends CalendarState, CalendarActions {}

export const createCalendarSlice: StateCreator<BoundStore, [["zustand/devtools", never]], [], CalendarSlice> = (
  set,
) => ({
  calendarSyncEnabled: false,
  calendarPermissionGranted: false,
  calendarPermissionDenied: false,
  setCalendarSyncEnabled: (enabled: boolean) => {
    set({ calendarSyncEnabled: enabled });
  },
  setCalendarPermissionGranted: (granted: boolean) => {
    set({ calendarPermissionGranted: granted });
  },
  setCalendarPermissionDenied: (denied: boolean) => {
    set({ calendarPermissionDenied: denied });
  },
  clearCalendars: async () => {
    await deleteAllEventrCalendars();
  },
});
